import React, { FC, ReactNode, useEffect, useState } from 'react';
import { FormLayout as FormLayoutCore } from 'ia-react-core';
import { getHostName } from 'omni-package-react-cms';
import { Trans } from 'react-i18next';
import { NeedHelp } from 'aw-package-react-authentication';
import { getHomePageUrl } from '~/utils/urlUtils';
import getSitecorePath from '~/utils/getSitecorePath';
import { useFooterLinks } from 'omni-package-react-core';
import MobileSmartBanner from '~/components/MobileSmartBanner';
import { StyledBackground, StyledDiv, FormLayoutGlobalStyles } from './FormLayout.styles';

export interface FormLayoutProps {
  children: ReactNode;
}

const FormLayout: FC<FormLayoutProps> = ({ children }) => {
  const footerUrl = getSitecorePath('global/footers/footer-non-authenticated', true, '/api/ssc/aggregate/content/Items/footer/');
  const sitecorePath = getHostName();
  interface FooterLink {
    text: string;
    url?: string;
    target?: '_blank' | '_self' | '_parent' | '_top' | undefined;
  }

  const [footerLinks, setFooterLinks] = useState<(FooterLink & { target?: string | undefined })[]>([]);
  const footerLinksFromOmniCore = useFooterLinks();
  useEffect(() => {
    if (footerLinksFromOmniCore) {
      const links: FooterLink[] = [
        ...footerLinksFromOmniCore,
      ];
      setFooterLinks(links);
    }
  }, [footerLinksFromOmniCore]);
  return (
    <>
      <FormLayoutGlobalStyles />
      <FormLayoutCore
        noFooterLanguageButton={false}
        mainFooterLinksUrl={footerUrl}
        mainFooterLinksDomain={`${sitecorePath}/cw`}
        mainFooterLinks={footerLinks}
        contentBackground="transparent"
        headerBackground="white"
        noHeaderLanguageButton
        homePageUrl={getHomePageUrl()}
        copyrightText={<Trans i18nKey="copyright">line1 <StyledDiv><br /></StyledDiv></Trans>}
      >
        <FormLayoutCore.BeforeHeader>
          <MobileSmartBanner></MobileSmartBanner>
        </FormLayoutCore.BeforeHeader>
        <FormLayoutCore.MainHeaderRightContent>
          <NeedHelp />
        </FormLayoutCore.MainHeaderRightContent>
        {children}
      </FormLayoutCore>
      <StyledBackground data-testid="StyledBackground" role="presentation" />
    </>
  );
};

export default FormLayout;
